<script setup>
import {computed, onMounted, ref} from "vue";
import store from "@/store";
import {payType} from "@/utils/config";
import XiamenLoginComponents from "@/components/xiamen/XiamenLoginComponents.vue";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";

const type = computed(() => {
  let pay = store.state.pay_type
  if (!pay) return {}
  pay = payType[pay]
  document.title = pay.title
  return pay
})
const login = ref(false)
const account = computed(() => {
  return store.state.account
})
const page = ref(1)
const last_page = ref(1)
const orderLst = ref([])
onMounted(() => {
  store.commit("getPayType")
  store.commit("getAccount")
  login.value = Object.keys(account.value).length < 1
  if (!login.value) {
    order()
  }
});
const order = () => {
  login.value = false
  new axiosApi({
    encode: "site",
    method: "coupon/orderLst",
    body: {
      uid: account.value.uid,
      page: page.value,
      business: type.value.platform
    }
  }).send((res) => {
    if (res.message.code === "000") {
      orderLst.value = page.value === 1 ? res.data.data : orderLst.value.concat(res.data.data)
      last_page.value = res.data.last_page
    }
  })
}
const score = ref()
const scrollbar = (refs) => {
  let warp = refs.wrapRef;
  const poor = warp.scrollHeight - warp.clientHeight;
  if (poor === parseInt(warp.scrollTop) || poor === Math.ceil(warp.scrollTop) || poor === Math.floor(warp.scrollTop)) {
    if (page.value < last_page.value) {
      page.value++;
      order()
    }
  }
}
</script>

<template>
  <!--  <el-page-header content="请选择支付方式" :content-class="'pay_type'" />-->
  <div class="page-header page-pid">
    <div @click="router.back()">
      <el-icon>
        <ArrowLeft/>
      </el-icon>
    </div>
    <div>我的订单</div>
    <div></div>
  </div>
  <el-scrollbar class="page-pid order-list" :style="type.view" v-if="orderLst.length" @scroll="scrollbar(score)" ref="score">
    <div class="order-item" v-for="ord in orderLst">
      <el-card>
        <div class="order-order-sn">
          <div class="order-info">订单编号：{{ ord.ordersn }}</div>
          <div class="order-state">
            <span v-if="ord.pay_status === 200">已支付</span>
            <span v-if="ord.pay_status === 0">未支付</span>
            <span v-if="ord.pay_status === 300">已取消</span>
            <span v-if="ord.pay_status === 500">已退款</span>
          </div>
        </div>
        <div class="order-details">
          <div class="order-details-label">消费券类型</div>
          <div class="order-details-value">{{ ord.couponItems.title }}</div>
        </div>
        <div class="order-details">
          <div class="order-details-label">付款账户</div>
          <div class="order-details-value">{{ ord.pay_type }}</div>
        </div>
        <div class="order-details">
          <div class="order-details-label">消耗积分</div>
          <div class="order-details-value">{{ ord.pay_score }}积分</div>
        </div>
        <div class="order-details">
          <div class="order-details-label">兑换时间</div>
          <div class="order-details-value">{{ ord.ctime }}</div>
        </div>
<!--        <div class="order-details">-->
<!--          <div class="order-details-label">交易流水号</div>-->
<!--          <div class="order-details-value">1234567890009876543221</div>-->
<!--        </div>-->
        <div class="order-details">
          <div class="order-details-label">使用状态</div>
          <div class="order-details-value">
            <span v-if="ord.used === 0">已过期</span>
            <span v-if="ord.used === 1 || ord.used === 3">
              <el-button link type="primary" @click="router.push({name:'orderDetail',query:{ordersn:ord.ordersn}})">去使用</el-button>
            </span>
            <span v-if="ord.used === 2 && ord.pay_status === 200">已使用</span>
            <span v-if="ord.used === 2 && ord.pay_status !== 200">支付异常</span>
          </div>
        </div>
      </el-card>
    </div>
  </el-scrollbar>
  <el-empty description="暂无订单" v-else/>
  <xiamen-login-components :show-login="login" @close="login=false" @login="order" v-if="type.type === 'xm_air'"/>
</template>

<style scoped lang="less">
.page-header {
  height: 45px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  border-bottom: var(--el-border);
}

.order-list {
  height: calc(100vh - 65px);

  /deep/ .el-card__body {
    padding: 10px 20px;
  }

  .order-item {
    margin: 0 20px 15px;

    .order-order-sn {
      position: relative;
      padding: 10px 0 20px;
      border-bottom: var(--el-border);
      margin-bottom: 15px;

      & > .order-info:after {
        content: '';
        position: absolute;
        height: 20px;
        left: -20px;
        width: 5px;
        background: var(--text-color);
        display: inline-block;
      }

      .order-state {
        position: absolute;
        right: -20px;
        height: 20px;
        line-height: 20px;
        background: var(--text-color);
        color: #ffffff;
        padding: 5px 15px 5px 25px;
        border-radius: 45px 0 0 45px;
        top: 5px;
      }
    }
  }

  .order-details {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    font-size: .85rem;

    .order-details-label {
      font-weight: 600;
    }

    .order-details-value {
      color: var(--el-color-info);
    }
  }
}
</style>
